import { CHAT_CONTEXT_PATH, CHAT_WS_URL } from '../const/AppConst';
import {
  ChannelStore,
  ChatStore,
  RSocket,
  Sort,
  TicketStore,
  QuickMsgStore,
} from '@qbot-chat/qbot-uikit';
import { reaction } from 'mobx';
import { navigate } from '../helper/HistoryHelper';
import { NotificationManager } from 'react-notifications';

const rSocket = new RSocket(
  CHAT_WS_URL,
  CHAT_CONTEXT_PATH,
  (error) => {
    let message = error?.response?.data?.message;
    NotificationManager.error(
      message || `${error.response?.status} ${error.response?.statusText}`,
    );
  },
  (message) => {
    NotificationManager.error(message);
  },
);

// rSocket.setNotificationHandler((type,message)=>{
// })

window.rSocket = rSocket;
const chatStore = new ChatStore();
chatStore.setInnerLinkFn(navigate);

const ticketStore = new TicketStore();
const quickMsgStore = new QuickMsgStore();

let channelStore = new ChannelStore({
  rowsPerPage: 10,
  paginationSize: 3,
  sort: new Sort('createdAt', Sort.SORT_DIRECTION.DESC),
});

export { rSocket, chatStore, channelStore, ticketStore, quickMsgStore };

// [디버그] 음성 모드 메시지 흐름 추적용 임시 window 노출.
if (typeof window !== 'undefined') {
  window.__chatStore = chatStore;
  window.__ticketStore = ticketStore;
}

// [디버그] front 가 받는 rSocket 메시지를 messageMap 크기 변화로 잡아 dump.
reaction(
  () => {
    const mm = chatStore.messageMap;
    if (!mm) return 0;
    if (typeof mm.size === 'number') return mm.size;
    if (Array.isArray(mm)) return mm.length;
    return Object.keys(mm).length;
  },
  (size, prevSize) => {
    if (size <= (prevSize ?? 0)) return;
    try {
      const mm = chatStore.messageMap;
      let last = null;
      if (mm) {
        if (typeof mm.values === 'function') {
          const arr = Array.from(mm.values());
          last = arr[arr.length - 1];
        } else if (Array.isArray(mm)) {
          last = mm[mm.length - 1];
        } else {
          const keys = Object.keys(mm);
          last = mm[keys[keys.length - 1]];
        }
      }
      const plain = last ? JSON.parse(JSON.stringify(last)) : null;
      // eslint-disable-next-line no-console
      console.log(
        `[socket] msg #${size - 1} type=${plain?.type} contentType=${plain?.contentType} sender=${plain?.sender?.type ?? '-'}(${plain?.sender?.name ?? '-'}) text="${plain?.textData ?? plain?.content?.value ?? ''}"`,
        plain,
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('[socket] dump failed:', e);
    }
  },
);
